module.exports = __webpack_public_path__ + "img/logo.6490ae60.png";